import { ButtonLink } from '@sbab-ui/components'
import { MouseEvent } from 'react'

const inDevelopmentEnv = process.env.NODE_ENV !== 'production'

const mockedQueryString = `?Typ=3&TypBenamning=Bostadsrätt&objekttyp=410&Pris=2095000&Drift=6720&Byggt=0&Tax=0&Arrende=0&Tomtr=0&Avgift=5504&Adress=Ekilla%20gårdsväg%2040&KommunKod=01:91&KommunBenamning=Sigtuna&Boarea=94&Biarea=0&postnr=0&supplier=5&brokerid=13639&WT.mc_id=0001&hemnetid=19352516&image=https://picsum.photos/id/1040/300/350&utm_source=hemnet&utm_medium=integration&utm_content=btn_bolanekalkylen_v2&utm_campaign=lanelofte`

function handleButtonLinkClick(event: MouseEvent) {
  event.preventDefault()
  window.location.href = `/${mockedQueryString}`
}

function MockQueryButton() {
  if (!inDevelopmentEnv) return null
  return (
    <ButtonLink
      variant="primary"
      size="large"
      className="mb-10 w-full sm:w-auto"
      style={{ color: '#fff!important' }}
      onClick={handleButtonLinkClick}
    >
      Click button to get dev data
    </ButtonLink>
  )
}

export default MockQueryButton
